'use strict';
angular.module('valleyCraftApp').directive('loading', function () {
  return {
    restrict: 'E',
    replace: true,
    template: '<div class="loading">' +
      '<div class="loading-overlay"></div>' +
        '<div class="loading-content">' +
          '<img src="assets/images/loading.gif" width="72" height="72" />' +
        '</div>' +
      '/div',
    link: function postLink (scope, element, attr) {

      scope.$watch('isLoading', function (v) {
        if (v) {
          $(element).show();
        } else {
          $(element).hide();
        }
      });
    }

  }
});

angular.module('valleyCraftApp').directive('loadingBg', function () {
  return {
    restrict: 'E',
    replace: true,
    template: '<div class="loading-bg">' +
      '<div class="loading-overlay"></div>' +
        '<div class="loading-content">' +
          '<img src="assets/images/loading.gif" width="72" height="72" />' +
        '</div>' +
      '/div',
    link: function postLink (scope, element, attr) {

      scope.$watch('isLoadingBg', function (v) {
        if (v) {
          $(element).show();
        } else {
          $(element).hide();
        }
      });
    }

  }
});
